var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"envelope-face-container title text-uppercase"},[_c('div',{staticClass:"envelope-face-text"},[_vm._v(" "+_vm._s(_vm.lodash.get(_vm.envelope, 'user.list_name', ''))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }